import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const fmt = (d) => (d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "");
const parse = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

// On-brand (midnight/charcoal/gold) single-date filter field replacing the native date input.
export function DateField({ value, onChange, placeholder = "Any date", testid }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className="inline-flex items-center gap-2 rounded-lg border border-gold/20 bg-obsidian-900 px-3 py-2 text-xs text-ivory outline-none transition hover:border-gold/50 focus:border-gold/60">
          <CalendarDays className="h-3.5 w-3.5 text-gold/70" />
          <span className={value ? "text-ivory" : "text-ivory/40"}>{value || placeholder}</span>
          {value && (
            <span role="button" aria-label="Clear date" data-testid={`${testid}-clear`} onClick={(e) => { e.stopPropagation(); onChange(""); }} className="ml-1 text-ivory/40 hover:text-gold">
              <X className="h-3 w-3" />
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto border-gold/25 bg-obsidian-800 p-0 text-ivory">
        <Calendar
          mode="single"
          selected={parse(value)}
          onSelect={(d) => { onChange(fmt(d)); setOpen(false); }}
          initialFocus
          classNames={{
            caption_label: "text-sm font-medium text-ivory",
            nav_button: "h-7 w-7 rounded-md border border-gold/25 text-ivory/70 hover:text-gold",
            head_cell: "w-8 rounded-md font-normal text-[0.8rem] text-gold/60",
            day: "h-8 w-8 rounded-md p-0 font-normal text-ivory/80 hover:bg-gold/15",
            day_selected: "bg-gold text-obsidian-900 hover:bg-gold hover:text-obsidian-900 focus:bg-gold focus:text-obsidian-900",
            day_today: "border border-gold/40 text-gold",
            day_outside: "text-ivory/25",
            day_disabled: "text-ivory/20",
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
